import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Shop() {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/shop/my-participants');
  }, []);
  return (<></>);
}